<template>
    <div>
        <!-- <div>{{subTitle}}</div> -->
        <section class="phone">
            <iframe class="demo-page" :src="previewUrl" frameborder="0"></iframe>
        </section>
    </div>
</template>
<script>
export default {
components:{
},
name: 'previewPage',
data() {
    return{
        previewUrl:this.$route.query.previewUrl,
        subTitle:''
    }

},
created() {
    document.title = localStorage.threeLevels + '功能配置预览';
},
};
</script>
<style scoped>
.phone{
    margin: 0px auto;
    background-image: url(../assets/phone.5909f66.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
    padding: 90px 15px 0 15px;
    width: 375px;
    height: 700px;
}
.demo-page{
    width: 375px;
    height: 590px;
    background-color: #fff;
}

</style>

  